module.exports = __webpack_public_path__ + "static/media/xls.65b63515.svg";